/* src/app/modules_v2/booking/locations/components/sections/location-service-section/location-service-bulk-add-dialog.component.css */
.bulk-add-dialog {
  width: 100%;
  max-width: 700px;
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  margin: -24px -24px 0 -24px;
}
.dialog-header h2 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.dialog-header h2 mat-icon {
  color: #666;
}
.close-button {
  margin-right: -12px;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  padding: 24px !important;
  max-height: 60vh;
  overflow-y: auto;
}
.description {
  margin-bottom: 20px;
}
.description p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.w-100 {
  width: 100%;
}
.mb-3 {
  margin-bottom: 20px;
}
.concepts-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  background: #fafafa;
}
.concept-item {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;
  transition: all 0.2s;
}
.concept-item:last-child {
  margin-bottom: 0;
}
.concept-item:hover {
  border-color: var(--cf-brand-dark);
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.1);
}
mat-checkbox,
.mat-mdc-checkbox {
  width: 100%;
}
.concept-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 8px;
}
.concept-main {
  display: flex;
  align-items: center;
  gap: 10px;
}
.concept-name {
  font-weight: 600;
  font-size: 15px;
  color: #333;
}
.already-added-badge {
  display: inline-block;
  padding: 2px 8px;
  background: #e0e0e0;
  color: #666;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}
.concept-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.concept-description {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}
.concept-meta {
  display: flex;
  gap: 15px;
}
.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #888;
}
.meta-item mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.filter-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
}
.filter-empty mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #ccc;
  margin-bottom: 10px;
}
.filter-empty p {
  margin: 0;
  font-size: 14px;
  color: #999;
}
.selection-summary {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;
  padding: 12px;
  background: #f9ffe0;
  border-left: 3px solid var(--cf-brand-dark);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: var(--cf-brand-dark);
}
.selection-summary mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--cf-brand-dark);
}
.selected-concepts {
  margin-top: 20px;
  padding: 15px;
  background: #f5f5f5;
  border-radius: 8px;
}
.selected-concepts h6 {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.selected-list mat-chip-list,
.selected-list mat-chip-listbox,
.selected-list mat-chip-grid,
.selected-list mat-chip-set,
.selected-list .mat-mdc-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.selected-list mat-chip,
.selected-list mat-chip-option,
.selected-list mat-chip-row,
.selected-list .mat-mdc-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: var(--cf-brand-dark);
  color: white;
  border-radius: 16px;
  font-size: 13px;
}
.chip-remove {
  width: 20px;
  height: 20px;
  padding: 0;
  margin-left: 4px;
}
.chip-remove mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.8);
}
.chip-remove:hover mat-icon {
  color: white;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px !important;
  margin: 0 -24px -24px -24px;
  border-top: 1px solid #e0e0e0;
  gap: 10px;
}
@media (max-width: 768px) {
  .bulk-add-dialog {
    max-width: 100%;
  }
  .dialog-header {
    padding: 16px 20px;
  }
  mat-dialog-content,
  .mat-mdc-dialog-content {
    padding: 20px !important;
  }
  .concepts-list {
    max-height: 300px;
  }
  mat-dialog-actions,
  .mat-mdc-dialog-actions {
    flex-direction: column-reverse;
  }
  mat-dialog-actions app-button,
  .mat-mdc-dialog-actions app-button {
    width: 100%;
  }
}
/*# sourceMappingURL=location-service-bulk-add-dialog.component.css.map */
